import { otto, OttoNexus } from '@otto-ec/global-resources/nexus';
import './nexus-global';

export type VideoApi = OttoNexus['ft5']['core']['video'];
const video: VideoApi = otto.ft5.core.video;
export const initVideoPlayer: VideoApi['initVideoPlayer'] = video.initVideoPlayer;
